import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import americanoPng from '../assets/formats/americano.png';
import mexicanoPng from '../assets/formats/mexicano.png';

function ImageIcon({ src, alt, size, sx, ...props }) {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        width: size,
        height: size,
        display: 'block',
        objectFit: 'contain',
        ...sx,
      }}
      {...props}
    />
  );
}

ImageIcon.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  size: PropTypes.number,
  sx: PropTypes.object,
};

ImageIcon.defaultProps = {
  alt: '',
  size: 24,
  sx: undefined,
};

export function AmericanoIcon(props) {
  return <ImageIcon src={americanoPng} {...props} />;
}

export function MexicanoIcon(props) {
  return <ImageIcon src={mexicanoPng} {...props} />;
}

export function FormatIcon({ format, ...props }) {
  return format === 'mexicano' ? <MexicanoIcon {...props} /> : <AmericanoIcon {...props} />;
}

FormatIcon.propTypes = {
  format: PropTypes.string,
};
